import { render, staticRenderFns } from "./right-suspension.vue?vue&type=template&id=ae877c94&scoped=true"
import script from "./right-suspension.vue?vue&type=script&lang=js"
export * from "./right-suspension.vue?vue&type=script&lang=js"
import style0 from "./right-suspension.vue?vue&type=style&index=0&id=ae877c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae877c94",
  null
  
)

export default component.exports